module.exports = __webpack_public_path__ + "1bb293efa20d54fd5c8b9eff6ec52e48.svg";